import React, { useCallback } from 'react';
import Col from 'react-bootstrap/Col';
import { createUseStyles } from 'react-jss';
import Slider from '../../components/Slider';
import Text from '../../components/Text';
import ProductCard from '../../components/ProductCard';
import Button from '../../components/Button';
import LinkButton from '../../components/LinkButton';
import { Link } from 'react-router-dom';

export interface SpotLightCardProps {
    spotLight: any
}

const SpotLightCard: React.FC<SpotLightCardProps> = ({ spotLight }) => {
    const classes = useStyles();
    const handleGoToExplorer = useCallback(() => {

    }, [spotLight]);
    return (
        <>
            <Link to={"search?" + spotLight.parametar}>

                <div className={classes.spotLight}  style={{ backgroundImage: `url(${spotLight.photo})` }}>
                    <Text bold as="p" fontSize="size2" className={classes.paragraph}>
                        {/* {spotLight.name} */}
                    </Text>
                    <LinkButton isLink to={"search?" + spotLight.parametar}
                        rounded className={classes.button}>
                        <Text bold color="white">Explore</Text>
                    </LinkButton>
                </div>
            </Link>
        </>
    )
}


const useStyles = createUseStyles({
    spotLight: {
        width: "calc(100% - 0px)",
        height: "225px",
        margin: '15px 0px',
        position: "relative",
        borderRadius: "10px",
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        padding: '40px 20px',
        backgroundSize: 'cover',
        display: 'table'
    },
    paragraph: {
        position: 'absolute',
        top: '50px',
        width: '33%'
    },
    button: {
        position: 'absolute',
        bottom: '50px',
        padding: "10px 40px"
    }
})
export default SpotLightCard